import { Fragment, useState, useCallback } from "react";
import { Table, Input, Checkbox } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { useRequest } from "ahooks";
import { department as departmentService } from "@/services";

function DepartmentTable({ rows, type, token, onChange }) {
  const [keyword, setKeyword] = useState();
  const [pageSize, setPageSize] = useState(50);
  const [page, setPage] = useState(1);
  const { data = { count: 0, results: [] }, loading } = useRequest(
    () => {
      return departmentService.list(
        {
          search: keyword,
          page,
          page_size: pageSize,
          types: type === "all" ? undefined : type,
        },
        token.token
      );
    },
    {
      ready: !!token.token,
      refreshDeps: [keyword, page, pageSize, type],
      throttleWait: 600,
    }
  );
  const changeHandler = useCallback(
    (id, name, checked) => {
      onChange(id, name, checked);
    },
    [onChange]
  );
  const columns = [
    {
      title: "选择",
      width: 80,
      key: "checkbox",
      render: (record, index) => {
        const checked = rows.find((v) => v.id === record.id);
        return (
          <Checkbox
            checked={checked}
            onChange={(e) =>
              changeHandler(record.id, record.name, e.target.checked)
            }
          />
        );
      },
    },
    {
      title: "单位名称",
      dataIndex: "name",
    },
  ];
  return (
    <Fragment>
      <div className="table-toolbar">
        <div className="left"></div>
        <div className="right">
          <Input
            prefix={<SearchOutlined style={{ color: "#ccc" }} />}
            style={{ width: 220 }}
            placeholder="搜索内容"
            allowClear
            onChange={(e) => setKeyword(e.target.value)}
          />
        </div>
      </div>
      <Table
        rowKey="id"
        size="small"
        columns={columns}
        dataSource={data.results}
        loading={loading}
        pagination={{
          size: "small",
          pageSize: pageSize,
          total: data.count,
        }}
        onChange={({ current, pageSize }) => {
          setPage(current);
          setPageSize(pageSize);
        }}
        scroll={{ y: 360 }}
      />
    </Fragment>
  );
}

export default DepartmentTable;
